export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500">有想看的内容？欢迎投稿或联系我们</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-100 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 text-center">
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-primary-50 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-xl text-primary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">tougao@7777.tv</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-accent-50 flex items-center justify-center mb-3">
                <i className="ri-customer-service-2-line text-xl text-accent-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1">客服咨询</h3>
              <p className="text-xs text-foreground-500">kefu@7777.tv</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-12 h-12 rounded-full bg-secondary-50 flex items-center justify-center mb-3">
                <i className="ri-flag-2-line text-xl text-secondary-600 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">fankui@7777.tv</p>
            </div>
          </div>
          <p className="mt-8 text-center text-xs text-foreground-400">
            工作时间：周一至周日 9:00-24:00 | 一般将在2小时内回复
          </p>
        </div>
      </div>
    </section>
  );
}